module.exports = __webpack_public_path__ + "static/media/discount.e4d37103.png";